var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticClass:"profile-index"},[_c('TitleBreadcrumb'),_c('router-view',{attrs:{"name":"routerviewprofile"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }